import React, { useState } from 'react';
import './styles.css';
import { Box, Paper, Typography, Tabs, Tab } from '@mui/material';
import 'bootstrap/dist/css/bootstrap.css';
import SettingBasicComp from '../components/setting/settingBasicComp';
import SubscriptionOverview from '../subscription';
import InvoiceHistory from '../invoices';

export default function BusinessSetting() {
  const [tabValue, setTabValue] = useState(0);

  return (
    <Box sx={{ width: '100%', p: { xs: 1, md: 2 } }}>
      <Typography variant='h5' sx={{ fontWeight: 700, color: '#1f2937', mb: 3 }}>
        Settings
      </Typography>

      <Paper
        elevation={0}
        sx={{ borderRadius: 3, border: '1px solid #e5e7eb', bgcolor: 'white', overflow: 'hidden' }}
      >
        <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 3 }}>
          <Tabs
            value={tabValue}
            onChange={(_, v) => setTabValue(v)}
            aria-label='settings tabs'
            sx={{
              '& .MuiTab-root': { textTransform: 'capitalize', fontWeight: 500, color: '#6b7280' },
              '& .Mui-selected': { color: '#2563eb', fontWeight: 600 },
              '& .MuiTabs-indicator': { backgroundColor: '#2563eb' },
            }}
          >
            <Tab label='Basic Info' />
            <Tab label='Subscription' />
            <Tab label='Invoices' />
          </Tabs>
        </Box>

        <Box sx={{ p: tabValue === 0 ? 3 : 0 }}>
          {tabValue === 0 && <SettingBasicComp />}
          {tabValue === 1 && <SubscriptionOverview embedded />}
          {tabValue === 2 && <InvoiceHistory embedded />}
        </Box>
      </Paper>
    </Box>
  );
}
